define('models/CategoryModel',['underscore', 'ObjectModel', 'LocalStorage', 'UrlFactory', 'app', 'router', 'moment', 'formatPrice'], function (_, ObjectModel, LocalStorage, UrlFactory, app, router, moment, formatPrice) {
    //
    // Model Category
    //
    var CategoryModelPrototype = {

        name:'CategoryModel',
        idAttribute:'id_category',
        route:'apiCategoryModel',
        isSync:true,

        defaults:{
            products:function(){return []} // si aucun produits, on créé un tableau vide
        },

        initialize:function(){
            // ObjectModel constructor heritage
            ObjectModel.prototype.initialize.apply(this,arguments);
            //
            if(!this.get(this.idAttribute)){
                this.attributes[this.idAttribute] = this.get('id');
            }
        },
        getUrl:function(ignoreBaseUrl){
            return UrlFactory.getUrl('category',{category_link_rewrite:this.get('link_rewrite')},ignoreBaseUrl);
        },
        getCustomerGroup:function () {
             var model = this;

            return model.get('customer_group');
        },
        getTitleColor: function () {
            return this.get('title_color') || '';
        },
        getPictureUrl:function(format){
            // TODO
            //
            var url, model = this,
                isDesktop = app.isDesktop(),
                type = isDesktop ? 'wide':'menuThumb',
                picture, extension = 'JPG';

            // filtre les images pour obtenir la couverture
            _(this.get('pictures')).each(function(p){
                if(!picture && _(p.types).contains(type)){
                    picture = p;
                }
            });

            if(picture){
                var rewrite = picture.legend || model.getName();
                if(!format){
                    format = isDesktop ? '1920x640' : '640x360';
                }
                url = UrlFactory.getUrlPicture(picture.id_object_picture,'category',format,rewrite,extension);
            }
            //
            return url || "/FRONTOFFICE/views/risingsun/medias/img/listing-test2.jpg";
        },
        getName:function(){return this.get('name')},
        getShortName:function(){return this.get('short_name') || this.getName()},
        getTitle:function(){
            return this.get('title_seo') || this.getName();
        },
        getDescription:function(){return this.get('description')},
        getLinkRewrite:function(){return this.get('link_rewrite')},
        getProductsId:function(){
            // retourne un tableau d'id_product
            var model = this,
                ids = model.get('products');
            if(model.id === app.c('_REORDER_CATEGORY_ID_')){
                var reorders = app.getCustomer().getReorders();
                reorders.forEach(function(order,i){
                   if(i>2) return;
                   ids = _.union(ids,order.get('products'));
                });
            }
            if(model.get('devaticsStrategyId')){
                // gestion devatics des produits contextualisés et limités
                var maxDevaticsProduct = parseInt(app.c('_DEVATICS_PRODUCTS_MAX_',false)),
                    n = 0;
                if(maxDevaticsProduct>0){
                    ids = _(ids).filter(function(id){
                        // on ignore dès que le maximum est dépassé
                        if(n>=maxDevaticsProduct){
                            return false;
                        }
                        var product = app.getProduct(id);
                        // on sélectionne les produits actifs dans le contexte
                        if(product && product.isVisibleInContext()){
                            n++;
                            return true;
                        }else{
                            return false;
                        }
                    });
                }

            }
            return ids;
        },
        getParts:function(nbr) {
           var  products = this.getProducts().models
           return _(products.slice(0,nbr));
        },
        getProductsCount:function(inContext,withFilters,cart){
            // retourne le nombre de produit de la catégorie
            if(inContext || withFilters){
                return this.getProducts(inContext,false,withFilters,cart).size();
            }else{
                return this.getProductsId().length;
            }
        },
        getLabelColor:function(){
            // sur mobile le menu devient titre, on utilise la couleur de titre.
            return this.get(app.isDesktop()?'label_color':'title_color');
        },
        getTemplateNav:function () {
            var model = this,
                templates = window.templates,
                templatenav = model.get('templateNav');

            if (templatenav && templates[templatenav])
            {
                return templates[templatenav];
            }else
            {
                return templates.blocksCategoryNavLine;
            }

            //  return templates.ComponentsVodTemplatesSidedishBlock;
        },
        getTemplate:function () {
            var model = this,
                templates = window.templates,
                templateSidedish = model.get('template');

            if (templateSidedish && templates[templateSidedish])
            {
                return templates[templateSidedish];
            }else
            {
                return templates['category'];
            }

            //  return templates.ComponentsVodTemplatesSidedishBlock;
        },
        runTemplate:function (templateProps) {
          var model = this;
            var template = model.getTemplate();
            try{
                return template(templateProps);
            }catch (e){
                app.error(e);
                return "<div class='category category-"+model.id+"'><div class='alert alert-danger'>Template error on category "+model.getName()+"</div></div>";
            }
        },
        getBanners:function(){
            var banners = this.get('banners');

            return _(banners);
        },
        getElements:function(cart){
            var model = this,
                products = !!cart ? model.getProductsCart() : model.getProducts();
            var elements = products,
                banners = model.getBanners();

            banners.each(function(e) {
                var banner = app.getBanner(e.id_banner);
                if (banner.isVisibleInContext()) {
                    elements.models.splice(e.position, 0, banner)
                    elements.length ++;
                }
            })

            return elements;
        },
        getProducts:function(inContext,inContextBuyable,withFilters, cart){
            // retourne une ProductCollection des produits de la catégorie
            var productsId = this.getProductsId(),
                products = app.getProducts().getProductsByIds(productsId, inContext, inContextBuyable, withFilters, cart);
            return products;
        },
        getProductsCart:function(cart){
            // raccourci sans les premiers parametre
            return this.getProducts(false,false,false,cart);
        },
        isEmpty:function(inContext,withFilters,cart){
            //
            // Exception :
            // si on est devatics, et pas encore synchronisé, alors on concidère qu'il va y avoir des produits...
            if(!this.isSync && this.get('devaticsStrategyId')){
                return false;
            }
            return this.getProductsCount(inContext,withFilters,cart)<=0;
        },
        isEnable:function(cart){
            var enable = this.get('enable');
            switch(enable){
                case 'always': return true;
                default :
                    if(enable.from){
                        enable.from = enable.from.replace(/-/g,'/');
                    }
                    if(enable.to){
                        enable.to = enable.to.replace(/-/g,'/');
                    }
                    var cart = defaultCart(cart),
                        contextMoment = cart.validateDeliveryOptions() ? cart.getDatetimeMoment() : moment(new Date()),
                        from = new Date(enable.from),
                        to = new Date(enable.to),
                        isAfterFrom = contextMoment.isAfter(from),
                        isBeforeTo = contextMoment.isBefore(to);
                    //
                    return     (enable.from && enable.to && isAfterFrom && isBeforeTo)
                            || (enable.from && isAfterFrom)
                            || (enable.to && isBeforeTo)
            }
        },
        containsId:function(id_product){
            return _(this.getProductsId()).contains(id_product);
        },
        isNavigationByDesire:function(strict){
            // l'option strict permet de ne pas vérifier que la catégorie appartient également au menu principal.
            return this.get('is_navigation_by_desire') && (strict || !this.get('active_menu'));
        },
        isVisibleInContext:function(cart){
            // basé sur la visibilité jour de la semaine + horaire
            var category = this,
                v = category.get('visibility'),
                period, cartDate, cartDay, from, to;
            //
            if (_(category.getCustomerGroup()).intersection(app.getCustomer().getCustomerGroup()).length == 0)
            {
                return false;
            }
            // si non défini, pas de restriction
            if(_.isUndefined(v)) return true;

            // sinon, on regarde le panier
            cartDate = defaultCart(cart).getDatetime();
            if(_.isUndefined(cartDate)) return true;

            if(_.isArray(v)){
                var day = cartDate.getDay();
                period = v[day];
            }else if(_.isObject(v)){
                period = v;
            }
            //
            if(period == 'always') return true;

            cartDay = moment(cartDate).format('YYYY/MM/DD ');
            from = new Date(cartDay+period.from);
            to = new Date(cartDay+period.to);

            // test si l'horaire du panier correspond à celui du créneau
            return moment(cartDate).isBetween(from,to);
        },
        isActiveInContext:function(withFilters,cart){
            // dans le contexte,
            // en incluant les non-achetables
            // withFilters en option
            return !this.isEmpty(true,withFilters,cart) && this.isEnable(cart) && this.isVisibleInContext(cart) ;
        },
        afterInitialize:{},
        //
        // devatics recommandations produits
        //
        setupDevatics:function(){
            var model = this;
            model.isSync = false;
            model.set({
                devaticsStrategyId:app.c('_DEVATICS_STRATEGY_ID_','33'),
                productsDefault:model.get('products')
            });
        },
        setupFavorites:function(){
            var model = this;
            if(app.getCustomer().isLogged()) {
                model.fetchFavorites();
                model.listenTo(app, 'FavoritesChange', model.fetchFavorites);
            }else{
                model.listenTo(app.getCustomer(), 'login', model.setupFavorites);
            }
        },
        //isDevatics:function(){return !!this.get('devaticsStrategyId');},
        fetchDevatics:function(){
            var model = this, customer = app.getCustomer(), options = {};
            model.isSync = false;
            if(customer.isLogged()){
                options.clientId = customer.id;
            }
            function dvt_fail(){
                dvt_success(model.get('productsDefault'),'reco_dvt_fail');
                model.trigger('devaticsFail',model);
            }
            function dvt_success(product_ids,recoId){
                // à chaque fois qu'on se connecte / déconnecte, on relancera un fetch sur la catégorie
                model.listenToOnce(customer, 'logout login', model.fetchDevatics);
                // gestion du nombre maximum à afficher sur la catégorie devatics
                model.isSync = true;
                model.set({
                    products:product_ids,
                    devaticsRecoId:recoId
                });
                // dispatch un evenement global pour indiquer qu'une categorie à été mise à jour
                app.trigger('categoryUpdate',model);
            }
            try {
                dvt_reco(model.get('devaticsStrategyId'), function (data) {
                    dvt_success(data.ids,data.recoId);
                }, options, dvt_fail);
            }catch(err){
                dvt_fail();
            }
        },
        fetchFavorites: function(){
            var model = this;
            try {
                model.set('products', app.getCustomer().get('likes'));
            }catch(err){
            }
        },
        getLowerPrice:function(){
            var lowerPrice = Infinity;
            this.getProducts(true,false).each(function(product){
                lowerPrice = Math.min(product.getPrice(),lowerPrice);
            });
            lowerPrice = lowerPrice == Infinity ? 0 : lowerPrice;
            return lowerPrice;
        },
        formatLowerPrice:function(){
            return formatPrice(this.getLowerPrice());
        }
    };

    function defaultCart(cart){
        return cart ? cart : app.getCart();
    }

    var CategoryModel = ObjectModel.extend(LocalStorage).extend(CategoryModelPrototype);

    return CategoryModel;
});
